import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: { persistSession: false },
});

// ============ API FUNCTIONS ============
// Same interface as before — pages don't need to change.

export async function fetchCategories() {
  const { data, error } = await supabase
    .from("categories")
    .select("*")
    .order("sort_order", { ascending: true });
  if (error) throw error;
  return data || [];
}

export async function fetchCategory(slug) {
  const { data, error } = await supabase
    .from("categories")
    .select("*")
    .eq("slug", slug)
    .maybeSingle();
  if (error) throw error;
  if (!data) {
    const err = new Error("Category not found");
    err.status = 404;
    throw err;
  }
  return data;
}

export async function fetchProducts(params = {}) {
  let q = supabase.from("products").select("*");
  if (params.category) q = q.eq("category_slug", params.category);
  if (params.subcategory) q = q.eq("subcategory_slug", params.subcategory);
  const limit = params.limit || 100;
  q = q.limit(limit);
  const { data, error } = await q;
  if (error) throw error;
  return data || [];
}

export async function fetchProduct(slug) {
  const { data, error } = await supabase
    .from("products")
    .select("*")
    .eq("slug", slug)
    .maybeSingle();
  if (error) throw error;
  if (!data) {
    const err = new Error("Product not found");
    err.status = 404;
    throw err;
  }
  return data;
}

export async function createEnquiry(payload) {
  // Use an RPC (SECURITY DEFINER function) to bypass RLS cleanly.
  const { data, error } = await supabase.rpc("submit_enquiry", {
    p_name: payload.name,
    p_company: payload.company,
    p_phone: payload.phone,
    p_email: payload.email,
    p_requirement: payload.requirement,
    p_product_slug: payload.product_slug || null,
    p_product_name: payload.product_name || null,
    p_source: payload.source || "website",
  });
  if (error) throw error;

  // Fire-and-forget: trigger email notification Edge Function (if deployed)
  try {
    await supabase.functions.invoke("notify-enquiry", { body: data });
  } catch (e) {
    // Silently ignore — enquiry is already saved.
  }
  return data;
}

export const CONTACT = {
  phone: "+91 7296976875",
  phoneRaw: "917296976875",
  email: "sales@giftxpert.co",
  whatsapp: "917296976875",
  address: "1st Floor, Enkay Tower, Plot No. B&B1, Phase V, Vanijya Nikunj, Gurugram, Haryana 122016",
};
